module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('ul', {
    staticClass: "nav navbar-right be-user-nav"
  }, [_vm._c('li', {
    staticClass: "dropdown"
  }, [(_vm.allNotifications.length > 0) ? _vm._c('a', {
    staticClass: "notifications",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" "), _vm._c('span', {
    staticClass: "notification-count"
  }, [_vm._v(_vm._s(_vm.allNotifications.length))])]) : _vm._c('a', {
    staticClass: "notifications",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._c('i', {
    staticClass: "far fa-bell"
  })]), _vm._v(" "), _vm._c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "role": "menu"
    }
  }, [_vm._c('li', [_vm._c('NotificationList', {
    attrs: {
      "show-delete": false
    }
  })], 1)])]), _vm._v(" "), _vm._c('li', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_vm._c('li', [_vm._c('div', {
    staticClass: "user-info"
  }, [_vm._c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.currentUser.email))]), _vm._v(" "), _vm._c('div', {
    staticClass: "user-position online"
  }, [_vm._v("Available")])])]), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._c('span', {
    staticClass: "icon mdi mdi-home"
  }), _vm._v(" Subject Shelf")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'user-account'
      }
    }
  }, [_vm._c('span', {
    staticClass: "icon mdi mdi-face"
  }), _vm._v(" Account")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'user-settings'
      }
    }
  }, [_vm._c('span', {
    staticClass: "icon mdi mdi-settings"
  }), _vm._v(" Settings")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._c('span', {
    staticClass: "icon mdi mdi-power"
  }), _vm._v(" Logout")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/avatar.png",
      "alt": "Avatar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-751266a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/LoggedInLinks.vue
// module id = 685
// module chunks = 1